import type { EventRoute } from '@/shared/infrastructure/events/eventRouter';
import { familyKeys } from './queryKeys';

export function registerFamilyEvents(
  register: (eventType: string, route: EventRoute) => void,
): void {
  register('family.member.added', {
    getQueryKeys: (p) => [familyKeys.members(p.familyId as string)],
  });

  register('family.member.updated', {
    getQueryKeys: (p) => [
      familyKeys.members(p.familyId as string),
      familyKeys.member(p.memberId as string),
    ],
  });

  register('family.member.removed', {
    getQueryKeys: (p) => [familyKeys.members(p.familyId as string)],
  });

  register('family.settings.updated', {
    getQueryKeys: (p) => [
      familyKeys.detail(p.familyId as string),
      familyKeys.settings(p.familyId as string),
    ],
  });

  register('family.invitation.created', {
    getQueryKeys: (p) => [familyKeys.invitations(p.familyId as string)],
  });

  register('family.invitation.used', {
    getQueryKeys: (p) => [
      familyKeys.invitations(p.familyId as string),
      familyKeys.members(p.familyId as string),
    ],
  });
}
